import { z } from "zod";
export const ZBigInt = z.string().transform((str) => BigInt(str));
//# sourceMappingURL=ZBigInt.js.map